import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_vueyandexmaps_49cfee40 from 'nuxt_plugin_vueyandexmaps_49cfee40' // Source: ./vue-yandex-maps.js (mode: 'all')
import nuxt_plugin_deviceplugin_3e1a5121 from 'nuxt_plugin_deviceplugin_3e1a5121' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_image_748fac91 from 'nuxt_plugin_image_748fac91' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_50cc633e from 'nuxt_plugin_cookieuniversalnuxt_50cc633e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_5b67c536 from 'nuxt_plugin_pluginutils_5b67c536' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_25bae570 from 'nuxt_plugin_pluginrouting_25bae570' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_aaf50802 from 'nuxt_plugin_pluginmain_aaf50802' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_recaptcha_03278305 from 'nuxt_plugin_recaptcha_03278305' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_eceea0d4 from 'nuxt_plugin_axios_eceea0d4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_clickoutside_2bc8eaac from 'nuxt_plugin_clickoutside_2bc8eaac' // Source: ../plugins/click-outside (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_notificationsssr_c12eda12 from 'nuxt_plugin_notificationsssr_c12eda12' // Source: ../plugins/notifications-ssr (mode: 'all')
import nuxt_plugin_notificationsclient_6eb3b8c6 from 'nuxt_plugin_notificationsclient_6eb3b8c6' // Source: ../plugins/notifications-client (mode: 'client')
import nuxt_plugin_vtextmask_12d39dbf from 'nuxt_plugin_vtextmask_12d39dbf' // Source: ../plugins/v-text-mask (mode: 'all')
import nuxt_plugin_vcalendar_299c62ab from 'nuxt_plugin_vcalendar_299c62ab' // Source: ../plugins/v-calendar (mode: 'client')
import nuxt_plugin_vueapiquery_964c47d0 from 'nuxt_plugin_vueapiquery_964c47d0' // Source: ../plugins/vue-api-query (mode: 'all')
import nuxt_plugin_nocartmode_9db0234e from 'nuxt_plugin_nocartmode_9db0234e' // Source: ../plugins/nocart-mode (mode: 'all')
import nuxt_plugin_vue2touch_e8a84cd8 from 'nuxt_plugin_vue2touch_e8a84cd8' // Source: ../plugins/vue2-touch (mode: 'client')
import nuxt_plugin_plugin_61373452 from 'nuxt_plugin_plugin_61373452' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_authlocalredirect_3f81638d from 'nuxt_plugin_authlocalredirect_3f81638d' // Source: ../plugins/auth-local-redirect (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, user-scalable=1, initial-scale=1, maximum-scale=5"},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fwetz-favicon.ico"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fwetz-favicon.svg"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_vueyandexmaps_49cfee40 === 'function') {
    await nuxt_plugin_vueyandexmaps_49cfee40(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_3e1a5121 === 'function') {
    await nuxt_plugin_deviceplugin_3e1a5121(app.context, inject)
  }

  if (typeof nuxt_plugin_image_748fac91 === 'function') {
    await nuxt_plugin_image_748fac91(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_50cc633e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_50cc633e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5b67c536 === 'function') {
    await nuxt_plugin_pluginutils_5b67c536(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_25bae570 === 'function') {
    await nuxt_plugin_pluginrouting_25bae570(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_aaf50802 === 'function') {
    await nuxt_plugin_pluginmain_aaf50802(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_03278305 === 'function') {
    await nuxt_plugin_recaptcha_03278305(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_eceea0d4 === 'function') {
    await nuxt_plugin_axios_eceea0d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_2bc8eaac === 'function') {
    await nuxt_plugin_clickoutside_2bc8eaac(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_notificationsssr_c12eda12 === 'function') {
    await nuxt_plugin_notificationsssr_c12eda12(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notificationsclient_6eb3b8c6 === 'function') {
    await nuxt_plugin_notificationsclient_6eb3b8c6(app.context, inject)
  }

  if (typeof nuxt_plugin_vtextmask_12d39dbf === 'function') {
    await nuxt_plugin_vtextmask_12d39dbf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_299c62ab === 'function') {
    await nuxt_plugin_vcalendar_299c62ab(app.context, inject)
  }

  if (typeof nuxt_plugin_vueapiquery_964c47d0 === 'function') {
    await nuxt_plugin_vueapiquery_964c47d0(app.context, inject)
  }

  if (typeof nuxt_plugin_nocartmode_9db0234e === 'function') {
    await nuxt_plugin_nocartmode_9db0234e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2touch_e8a84cd8 === 'function') {
    await nuxt_plugin_vue2touch_e8a84cd8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_61373452 === 'function') {
    await nuxt_plugin_plugin_61373452(app.context, inject)
  }

  if (typeof nuxt_plugin_authlocalredirect_3f81638d === 'function') {
    await nuxt_plugin_authlocalredirect_3f81638d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
